import { IDataList } from 'redux-store/types';

export enum CompanyLocationStatusEnum {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export interface ICompanyLocation {
  id: number;
  name: string;
  status: CompanyLocationStatusEnum;
  companyId: number;
  createdAt: Date;
  updatedAt: Date;
}

export type TGetCompanyLocationsResponse = IDataList<ICompanyLocation>;

export interface IGetCompanyLocationsArgs {
  search?: string;
  status?: CompanyLocationStatusEnum;
  cursor?: number;
  limit?: number;
}

export interface ICreateCompanyLocationBody extends Pick<ICompanyLocation, 'name'> {}

export interface IUpdateCompanyLocationBody extends Pick<ICompanyLocation, 'id' | 'name'> {
  status?: CompanyLocationStatusEnum;
}
